module.exports = __webpack_public_path__ + "img/edit.91a27bae.svg";